import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const Wallpaper = React.memo(({ wallpaper, onAddToBasket, hasGenerated }) => {
  const [isAdded, setIsAdded] = useState(false);
  const [backgroundUrl, setBackgroundUrl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();


  const serverUrl = process.env.REACT_APP_API_BASE_URL;
  const frontendUrl = window.location.origin;

  const oldWallpapers = [
    "wallpapers/old/wallpaper01.jpg",
    "wallpapers/old/wallpaper02.jpg",
    "wallpapers/old/wallpaper03.jpg",
    "wallpapers/old/wallpaper04.jpg",
    "wallpapers/old/wallpaper05.jpg",
    "wallpapers/old/wallpaper06.jpg",
    "wallpapers/old/wallpaper07.jpg",
    "wallpapers/old/wallpaper08.jpg",
    "wallpapers/old/wallpaper09.jpg",
    "wallpapers/old/wallpaper010.jpg"
  ];

  useEffect(() => {
    const randomWallpaper = oldWallpapers[Math.floor(Math.random() * oldWallpapers.length)];
    console.log('Initial random wallpaper:', randomWallpaper);
    setBackgroundUrl(`${frontendUrl}/${randomWallpaper}`);
  }, [frontendUrl]);

  useEffect(() => {
    if (wallpaper) {
      const fullUrl = `${serverUrl}${wallpaper}`;
      console.log('Setting background URL:', fullUrl);
      setBackgroundUrl(fullUrl);
    }
    setIsAdded(false);
  }, [wallpaper, serverUrl]);

useEffect(() => {
  if (location.state?.addToBasket && !isAdded && hasGenerated) {
    handleAddToBasket();
  }
  // Clean up the state on back navigation so it doesn’t fire again
  window.history.replaceState({}, document.title);
}, [location.state, isAdded, hasGenerated]);


  const handleAddToBasket = () => {
    onAddToBasket();
    setIsAdded(true);
  };

  const handleVisualise = () => {
    if (backgroundUrl) {
      navigate('/visualise', {
        state: {
          wallpaperUrl: backgroundUrl
        }
      });
    }
  };

  console.log('Wallpaper URL:', backgroundUrl);

  return (
    <div className="wallpaper" style={{
      backgroundImage: `url(${backgroundUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh'
    }}>
	  <div className="overlay flex flex-col items-center justify-center w-full h-screen">
  {!hasGenerated && (
    <div className="intro-text bg-white p-4 rounded shadow-lg text-center mb-4 max-w-xl">
      <p>
        <strong>Turn your phone into a masterpiece.</strong><br />
        Generate a stunning, one-of-a-kind wallpaper — the only one in the world. Pair it with a premium matching phone case, made just for you.
        <br /><br />
        Wallpapers <strong>£2</strong>, instant download. Add a matching premium quality case from <strong>£15.50</strong>, individually UK printed and shipped same day.
      </p>
      <div className="mt-4 flex justify-center space-x-4">
        <Link to="/how-it-works" className="text-blue-500 hover:text-blue-700 underline">
          How it works
        </Link>
        <Link to="/phone-cases" className="text-blue-500 hover:text-blue-700 underline">
          Our cases
        </Link>
      </div>
    </div>
  )}

        {hasGenerated && (
          <div className="flex gap-4 mt-4">
            <button
              onClick={handleAddToBasket}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-300 ease-in-out"
              disabled={isAdded}
            >
              {isAdded ? 'Added' : 'Add to Basket'}
            </button>
            <button
              onClick={handleVisualise}
              className="bg-gray-600 hover:bg-gray-800 text-white font-bold py-2 px-4 rounded transition duration-300 ease-in-out"
            >
              Visualise
            </button>
          </div>
        )}
      </div>
    </div>
  );
});

export default Wallpaper;

